import { config } from '../config.js'
import { get } from '../services/http.js'

export let products = async function () {
  return await get(`${config.apiUrl}/products`, false)
}

export let getProduct = async function (id, showRelated=true) {
  if (id) {
    let query =`${config.apiUrl}/products/${id}`
    if (showRelated){
      query = `${query}?show-related=1`
    }
    return await get(query, false)
  }
}

export let getAttrs = async function (typeId) {
  return await get(`${config.apiUrl}/product_types/${typeId}/attr`, false)
}